
import { Component, Prop } from 'vue-property-decorator';
import { fileFormatType, InvoiceItemType, InvoiceStatuses } from '@/features/invoices/types';
import {
  useFormatTimestamp,
  downloadURI,
  showErrorAlertDialog,
  getPrice,
} from '@/features/common/helpers';
import { getInvoiceAsCSVOrExcel, getInvoiceAsPDF } from '@/features/invoices/services/invoices.services';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component
export default class InvoiceItem extends ResponsivenessMixin {
  @Prop({ required: true }) invoice!: InvoiceItemType;

  private isDownloading = false;

  private isExporting = false;

  get statusWithDesignClass(): {
      text: string,
      className: string,
      iconName: string,
      } {
    let className = '';
    let iconName = '';

    let text = this.$t(`invoices.statuses.${this.invoice.invoiceStatus}`) as string;

    switch (this.invoice.invoiceStatus) {
      case InvoiceStatuses.Open:
        className = 'orange--text';
        iconName = 'mdi-clock';
        break;
      case InvoiceStatuses.Paid:
      case InvoiceStatuses.Refunded:
      case InvoiceStatuses.Credit:
        className = 'teal--text text--lighten-2';
        iconName = 'mdi-check-circle';
        break;
      case InvoiceStatuses.PartiallyPaid:
        className = 'deep-purple--text text--lighten-2';
        iconName = 'mdi-timelapse';
        if (this.screenWidth < 600) {
          text = this.$t('invoices.statuses.PartiallyPaidInShort') as string;
        }
        break;
      default:
        className = '';
    }

    return {
      text,
      className,
      iconName,
    };
  }

  private useFormatTimestamp = useFormatTimestamp;

  private getPrice = getPrice;

  private async downloadDocument() {
    this.isDownloading = true;

    const blobResponse = await getInvoiceAsPDF(this.invoice.invoiceNumber);
    if (blobResponse && blobResponse.successful && blobResponse.data && blobResponse.url) {
      const fileExtension = 'pdf';
      await downloadURI(blobResponse.url, `${this.invoice.invoiceNumber}.${fileExtension}`, true);
    } else {
      showErrorAlertDialog(
        blobResponse.errorMessage || this.$t('alertDialog.somethingWentWrong') as string,
      );
    }

    this.isDownloading = false;
  }

  private async exportDocument(type: fileFormatType) {
    this.isExporting = true;

    const blobResponse = await getInvoiceAsCSVOrExcel(this.invoice.invoiceNumber, type);
    if (blobResponse && blobResponse.successful && blobResponse.data && blobResponse.url) {
      const fileExtension = type === 'Excel' ? 'xlsx' : 'csv';
      await downloadURI(blobResponse.url, `${this.invoice.invoiceNumber}.${fileExtension}`, false);
    } else {
      showErrorAlertDialog(
        blobResponse.errorMessage || this.$t('alertDialog.somethingWentWrong') as string,
      );
    }

    this.isExporting = false;
  }
}
